<template>
  <div class="team-page">
    <!-- 轮播图 -->
    <div class="banner">
      <div class="swiper-wrapper">
        <div class="swiper-slide"><img src="@/assets/goyb02.png" alt="" /></div>
        <div class="swiper-slide"><img src="@/assets/goyb03.png" alt="" /></div>
        <div class="swiper-slide"><img src="@/assets/goyb01.png" alt="" /></div>
      </div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>

    <!-- 团队简介标题 -->
    <div class="section-title">团队简介</div>

    <!-- 核心管理层 -->
    <div class="leaders-grid">
      <!-- 总经理 -->
      <div class="leader-card">
        <div class="leader-avatar">
            <div class="box">
          <img src="../../assets/tdjj/01.png" alt="杨天义" />
            </div>
        </div>
        <div class="leader-info">
          <div class="leader-name">杨天义</div>
          <div class="leader-title">翼博餐饮总经理</div>
          <div class="leader-tags">
            <span>兼任菜品研发中心负责人</span>
            <span>高级餐饮职业经理人</span>
            <span>食品安全管理师</span>
            <span>健康管理师</span>
            <span>30余年餐饮行业从业经验</span>
          </div>
        </div>
      </div>

      <!-- 副总经理 -->
      <div class="leader-card reverse">
        <div class="leader-avatar">
            <div class="box">
                <img src="../../assets/tdjj/02.png" alt="杨天龙" />
            </div>
        </div>
        <div class="leader-info">
          <div class="leader-name">杨天龙</div>
          <div class="leader-title">翼博餐饮副总经理</div>
          <div class="leader-tags">
            <span>兼任运营中心、产品研发中心负责人</span>
            <span>食品安全总监</span>
            <span>高级餐饮职业经理人</span>
            <span>高级物流师</span>
            <span>世界五百强企业20余年供应链管理经验</span>
            <span>曾任德邦物流、京东物流河南省区运营机构负责人</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 菜品研发中心 -->
    <div class="section-title">菜品研发中心</div>
    <div class="team-grid">
      <div class="team-card" v-for="chef in chefs" :key="chef.name">
        <div class="avatar">
          <img :src="chef.img" :alt="chef.name" />
        </div>
        <div class="card-body">
          <div class="card-title">{{ chef.title }}</div>
          <div class="card-name">{{ chef.name }}</div>
          <div class="card-badges">
            <span v-for="(tag, idx) in chef.tags" :key="idx">{{ tag }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 系统研发中心 -->
    <div class="section-title">系统研发中心</div>
    <div class="system-grid">
      <div class="system-card" v-for="dev in developers" :key="dev.name">
        <div class="avatar"><img :src="dev.img" :alt="dev.name" /></div>
        <div class="info">
          <div class="name">{{ dev.name }}</div>
          <div class="desc" v-for="(line, idx) in dev.desc" :key="idx">{{ line }}</div>
        </div>
      </div>
    </div>

    <!-- 厨房设计部 -->
    <div class="section-title">厨房设计部</div>
    <div class="design-section">
      <div class="designer-card">
        <div class="avatar"><img src="../../assets/tdjj/24.png" alt="陈晓飞" /></div>
        <div class="designer-info">
          <div class="designer-title">产品中心厨房设计金牌顾问</div>
          <div class="designer-name">陈晓飞</div>
        </div>
      </div>
      <div class="works-grid">
        <div class="works-column" v-for="(col, idx) in worksCols" :key="idx">
          <div class="work-item" v-for="work in col" :key="work">{{ work }}</div>
        </div>
      </div>
    </div>

    <!-- 行政管理中心 -->
    <div class="section-title">行政管理中心</div>
    <div class="admin-grid">
      <div class="admin-card" v-for="admin in admins" :key="admin.name">
        <div class="avatar"><img :src="admin.img" :alt="admin.name" /></div>
        <div class="name">{{ admin.name }}</div>
        <div class="role">{{ admin.role }}</div>
        <div class="extra" v-if="admin.extra">{{ admin.extra }}</div>
      </div>
    </div>

    <!-- 项目部（大堂经理） -->
    <div class="section-title">项目部</div>
    <div class="manager-grid">
      <div class="manager-card" v-for="manager in managers" :key="manager.name">
        <div class="avatar"><img :src="manager.img" :alt="manager.name" /></div>
        <div class="info">
          <div class="title">{{ manager.title }}</div>
          <div class="name">{{ manager.name }}</div>
          <div class="desc">{{ manager.desc }}</div>
        </div>
      </div>
    </div>

    <!-- 项目部负责人 -->
    <div class="section-title">项目部负责人</div>
    <div class="project-leaders">
      <div class="leader-item" v-for="leader in projectLeaders" :key="leader.name">
        <div class="avatar"><img :src="leader.img" :alt="leader.name" /></div>
        <div class="name">{{ leader.name }}</div>
        <div class="project">{{ leader.project }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { WOW } from 'wowjs'

export default {
  data() {
    return {
      chefs: [
        {
          img: require('../../assets/tdjj/09.png'),
          title: '菜品研发中心总监',
          name: '吴付徳',
          tags: ['高级公共营养师', '河南豫菜大师', '国家一级厨师', '中国青年御膳大师', '中国饭店协会名厨委员会委员', '第四届百鱼宴特金奖', '第二界“豫菜杯”竞赛特金奖', '河南省酒店餐饮业技术创新标兵']
        },
        {
          img: require('../../assets/tdjj/11.png'),
          title: '商务餐研发总厨',
          name: '张文举',
          tags: ['高级公共营养师', '河南豫菜大师', '高级技师', '第二届天娇美食节厨王争霸赛评委', '名厨名店委员会常务副秘书长', '第二届青年中西餐烹饪邀请赛青年裁判', '世界上最大的面气球1.8米保持者', '国际精厨争霸赛特金奖', '第25届中国厨师节两项特金奖', '河南省第四届豫菜品牌大赛特金奖']
        },
        {
          img: require('../../assets/tdjj/10.png'),
          title: '团餐研发总厨',
          name: '郑增辉',
          tags: ['从厨20余年', '河南团餐名厨', '高级烹调师', '翼博餐饮中机六院项目部厨师长', '擅长菜品创新']
        },
        {
          img: require('../../assets/tdjj/19.png'),
          title: '中式面点研发总厨',
          name: '陈强',
          tags: ['从厨20余年', '高级烹饪师', '曾任全国连锁企业店面经理', '郑州本土知名餐饮行业名厨', '精通各类中式面食，风味小吃']
        }
      ],
      developers: [
        {
          img: require('../../assets/tdjj/32.png'),
          name: '张慧芳',
          desc: ['系统研发中心前端工程师', '数据科学与大数据技术学士学位', '网站建设及维护', '网页、小程序、APP、公众号界面设计']
        },
        {
          img: require('../../assets/tdjj/22.png'),
          name: '王宏坤',
          desc: ['系统研发中心全栈工程师', '大数据技术与应用专业', '后台数据模型搭建', '系统版本升级及BUG修复']
        }
      ],
      worksCols: [
        ['宝丰县政府职工餐厅', '仟那酒店厨房及明档自助餐台', '平顶山市委党校5号楼厨房', '唐山锦江国际酒店厨房', '工人路阿勇美食宴会酒店厨房', '小刘桥阿勇美食宴会酒店', '鲁山兴源高中一二三楼学生餐厅厨房', '中牟丽枫宴会酒店厨房'],
        ['郑州机械研究所职工餐厅厨房', '平顶山第一人民医院餐厅厨房', '平顶山扶贫办职工餐厅厨房', '郑州沙口路半闲斋鲜肉涮厨房', '平顶山城建学院蓝青园餐厅厨房', '国机集团第六设计研究院职工餐厅厨房', '商丘莲溪高中一二三楼学生餐厅厨房', '郑州广电路半闲斋鲜肉涮厨房', '南阳理工学院餐厅厨房'],
        ['融通医疗天津二七二医院餐厅厨房', '叶县县委党校餐厅厨房及明档自助餐台', '西平阿勇美食宴会酒店厨房', '内蒙古呼伦贝尔贝尔大酒店宴会厨房', '中国船舶集团第七一三研究所职工餐厅', '中交城投（郑州）开发建设有限公司厨房', '商丘驻郑州办事处厨房', '白象总部三楼职工餐厅厨房', '......']
      ],
      admins: [
        { img: require('../../assets/tdjj/05.png'), name: '牛玉珂', role: '行政管理中心负责人', extra: '财务管理专业 / 管理学学士学位' },
        { img: require('../../assets/tdjj/21.png'), name: '张玉', role: '综合保障部负责人', extra: '财务管理专业' },
        { img: require('../../assets/tdjj/25.png'), name: '肖亚楠', role: '人力资源部负责人', extra: '人力资源本科学历 / 管理学学士学位' },
        { img: require('../../assets/tdjj/14.png'), name: '封秋侠', role: '财务部负责人', extra: '会计专业' }
      ],
      managers: [
        { img: require('../../assets/tdjj/26.png'), title: '团餐楼层经理', name: '李书红', desc: '多年团餐前厅主管服务经验，善于梳理供餐流程，做事风格雷厉风行。曾任某军工企业职工餐厅前厅经理，现任翼博餐饮项目部大堂经理。' },
        { img: require('../../assets/tdjj/20.png'), title: '商务餐楼层经理', name: '鲁晓丽', desc: '多年社会酒楼管理经验，曾在越秀酒家、皇府鲍鱼、金色港湾、咱家小院任楼层经理，现任翼博餐饮项目部大堂经理。' },
        { img: require('../../assets/tdjj/27.png'), title: '商务餐楼层经理', name: '杨雅然', desc: '多年会所管理经验，熟悉会所商务接待标准及流程，曾任地产会所负责人，现任翼博餐饮项目部大堂经理。' }
      ],
      projectLeaders: [
        { img: require('../../assets/tdjj/15.png'), name: '王西杰', project: '七一三项目经理' },
        { img: require('../../assets/tdjj/35.png'), name: '吴付徳', project: '海为酒店项目经理' },
        { img: require('../../assets/tdjj/34.png'), name: '郑增辉', project: '速达股份项目经理' },
        { img: require('../../assets/tdjj/03.png'), name: '武杨', project: '中机六院项目经理' },
        { img: require('../../assets/tdjj/08.png'), name: '魏长江', project: '中原工学院项目经理' },
        { img: require('../../assets/tdjj/31.png'), name: '张文举', project: '恒达智控项目经理' },
        { img: require('../../assets/tdjj/30.png'), name: '杨豪', project: '城建学院项目经理' },
        { img: require('../../assets/tdjj/06.png'), name: '武姚', project: '司法局项目经理' }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      const wow = new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
      })
      wow.init()
    })
    new Swiper(".banner", {
      loop: true,
      pagination: { el: ".swiper-pagination" },
      navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
      autoplay: { autoplay: true, disableOnInteraction: false },
    })
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.team-page {
  background-color: #f9fafb;
}

/* 轮播图 */
.banner {
  width: 100%;
  height: 3.5rem;
  overflow: hidden;
  position: relative;
}
.banner img {
  width: 100%;
  height: 100%;
  /* object-fit: cover; */
}
.swiper-button-prev,
.swiper-button-next {
  color: white;
  background: rgba(0, 0, 0, 0.4);
  width: 44px;
  height: 44px;
  border-radius: 50%;
  backdrop-filter: blur(4px);
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 20px;
}

/* 标题 */
.section-title {
  text-align: center;
  font-size: 30px;
  font-weight: 700;
  margin: 48px 0 32px;
  position: relative;
  letter-spacing: 2px;
  color: #1e293b;
}
.section-title:after {
  content: '';
  display: block;
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #f97316, #facc15);
  margin: 16px auto 0;
  border-radius: 4px;
}

/* 核心管理层卡片 */
.leaders-grid {
  max-width: 1200px;
  margin: 0 auto 40px;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.leader-card {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 32px;
  overflow: hidden;
  box-shadow: 0 20px 35px -12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}
.leader-card:hover {
  transform: translateY(-6px);
}
.leader-card.reverse {
  flex-direction: row-reverse;
}
.leader-avatar {
  flex: 1;
  padding: 24px;
  background: linear-gradient(135deg, #fef3e2, #fff);
  display: flex;
  justify-content: center;
}
.box {
    width:250px;height:250px;border-radius:50%;
    border-radius: 50%;
    box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.15);
    overflow: hidden;
}
.leader-avatar img {
  /* width: 100%; */
  /* max-width: 280px; */
  display: block;
  margin: 0 auto;
}
.leader-info {
  flex: 2;
  padding: 32px;
}
.leader-name {
  font-size: 28px;
  font-weight: 700;
  color: #f97316;
  margin-bottom: 8px;
}
.leader-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 20px;
  border-left: 4px solid #f97316;
  padding-left: 12px;
}
.leader-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.leader-tags span {
  background: #f1f5f9;
  padding: 6px 14px;
  border-radius: 40px;
  font-size: 16px;
  color: #334155;
}

/* 通用网格（菜品研发 / 行政管理） */
.team-grid,
.admin-grid {
  max-width: 80%;
  margin: 0 auto;
  padding: 0 24px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
}
.team-card,
.admin-card {
  background: #fff;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 12px 24px -10px rgba(0, 0, 0, 0.08);
  transition: all 0.3s;
  text-align: center;
  padding-bottom: 24px;
}
.team-card:hover,
.admin-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 30px -12px rgba(0, 0, 0, 0.15);
}
.team-card .avatar,
.admin-card .avatar {
  width: 160px;
  height: 160px;
  margin: 24px auto 16px;
  border-radius: 50%;
  overflow: hidden;
  background: #fef3e2;
  box-shadow: 0 8px 16px -6px rgba(0, 0, 0, 0.1);
}
.team-card .avatar img,
.admin-card .avatar img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.card-title {
  font-size: 16px;
  color: #f97316;
  font-weight: 500;
  margin-bottom: 6px;
}
.card-name {
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 16px;
}
.card-badges {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  padding: 0 16px;
}
.card-badges span {
  background: #f1f5f9;
  font-size: 14px;
  padding: 4px 12px;
  border-radius: 30px;
  color: #334155;
}
.admin-card .name {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 4px;
}
.admin-card .role {
  font-size: 16px;
  color: #f97316;
  font-weight: 500;
}
.admin-card .extra {
  font-size: 14px;
  color: #64748b;
  margin-top: 8px;
}

/* 系统研发中心 */
.system-grid {
  max-width: 1200px;
  margin: 0 auto 40px;
  padding: 0 24px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 30px;
}
.system-card {
  background: #fff;
  border-radius: 24px;
  display: flex;
  padding: 28px;
  gap: 28px;
  box-shadow: 0 12px 24px -10px rgba(0, 0, 0, 0.08);
  transition: 0.3s;
}
.system-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 30px -12px rgba(0, 0, 0, 0.15);
}
.system-card .avatar {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  overflow: hidden;
  background: #fef3e2;
  flex-shrink: 0;
}
.system-card .avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.system-card .info {
  flex: 1;
}
.system-card .name {
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 12px;
}
.system-card .desc {
  font-size: 16px;
  color: #475569;
  margin-bottom: 6px;
  line-height: 1.4;
}

/* 厨房设计部 */
.design-section {
  max-width: 1200px;
  margin: 0 auto 40px;
  /* padding: 0 24px; */
  background: #fff;
  border-radius: 32px;
  box-shadow: 0 12px 24px -10px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.designer-card {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 32px;
  background: linear-gradient(90deg, #fef3e2, #fff);
  border-bottom: 1px solid #f0f0f0;
}
.designer-card .avatar {
  width: 180px;
  height: 180px;
  border-radius: 50%;
  overflow: hidden;
  background: #fef3e2;
  box-shadow: 0 8px 16px -6px rgba(0, 0, 0, 0.2);
}
.designer-card img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.designer-info {
  flex: 1;
}
.designer-title {
  font-size: 18px;
  color: #f97316;
  font-weight: 500;
  margin-bottom: 6px;
}
.designer-name {
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
}
.works-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  padding: 32px;
  background: #f9fafb;
}
.works-column {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.work-item {
  font-size: 14px;
  color: #334155;
  line-height: 1.4;
  padding-left: 12px;
  border-left: 2px solid #facc15;
}

/* 项目部（大堂经理） */
.manager-grid {
  max-width: 80%;
  margin: 0 auto 40px;
  padding: 0 24px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
}
.manager-card {
  background: #fff;
  border-radius: 24px;
  display: flex;
  padding: 24px;
  gap: 20px;
  box-shadow: 0 12px 24px -10px rgba(0, 0, 0, 0.08);
  transition: 0.3s;
}
.manager-card:hover {
  transform: translateY(-6px);
}
.manager-card .avatar {
  width: 160px;
  height: 160px;
  background: #fef3e2;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}
.manager-card .avatar img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.manager-card .info {
  flex: 1;
}
.manager-card .title {
  font-size: 16px;
  color: #f97316!important;
  font-weight: 500;
  margin-bottom: 4px;
}
.manager-card .name {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 8px;
}
.manager-card .desc {
  font-size: 14px;
  color: #475569;
  line-height: 1.5;
}

/* 项目部负责人 */
.project-leaders {
  max-width: 80%;
  margin: 0 auto 60px;
  padding: 0 24px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
}
.leader-item {
  background: #fff;
  border-radius: 20px;
  text-align: center;
  padding: 20px 12px;
  transition: 0.3s;
  box-shadow: 0 8px 20px -8px rgba(0, 0, 0, 0.06);
}
.leader-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 25px -10px rgba(0, 0, 0, 0.1);
}
.leader-item .avatar {
  width: 160px;
  height: 160px;
  margin: 0 auto 12px;
  border-radius: 50%;
  overflow: hidden;
  background: #fef3e2;
}
.leader-item img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.leader-item .name {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 6px;
}
.leader-item .project {
  font-size: 18px;
  color: #f97316;
  font-weight: 500;
}

/* 响应式 */
@media (max-width: 900px) {
  .banner { height: 360px; }
  .section-title { font-size: 1.8rem; }
  .leader-card, .leader-card.reverse { flex-direction: column; text-align: center; }
  .leader-avatar { padding: 20px; }
  .leader-info { padding: 24px; }
  .leader-tags { justify-content: center; }
  .system-card { flex-direction: column; align-items: center; text-align: center; }
  .works-grid { grid-template-columns: 1fr; gap: 20px; }
  .manager-card { flex-direction: column; align-items: center; text-align: center; }
}

</style>